define('common/components/nunjucks-config/nunjucks-globals',['nunjucks'], function(Nunjucks) {
    'use strict';

    return {
        "core_static": function (relativeUrl) {
            var staticUrl = window.paths && window.paths.core_static || '/static/';
            return staticUrl + relativeUrl;
        },

        "edde_static": function (relativeUrl) {
            var staticUrl = window.paths && window.paths.edde_static || '/static/';
            return staticUrl + relativeUrl;
        },

        "get_DE_url": function (siteName) {
            var env,
                deDomain,
                appUrl,
                domain,
                pattern,
                matches,
                siteUrl;

            siteName = siteName.toLowerCase();

            // Remove the trailing slash from the rc value
            // so it doesn't interfere with the regex.
            appUrl = window.rc.appurl.replace(/\/$/, '');

            // Extract the ENV and DE_DOMAIN
            pattern = /^.+?(\.(?:local|dev|qa|stage))?\.(discoveryeducation\..+?)$/i;
            matches = pattern.exec(appUrl);
            if (matches === null) {
                  console.log('ERROR: get_DE_url cannot match domain ' + appUrl);
                  return null;
            }
            env = matches[1] || '';
            deDomain = matches[2];
            // 'static' always has a 'com' tld
            if (siteName === 'static') {
                deDomain = 'discoveryeducation.com';
            }
            domain = env + '.' + deDomain;

            siteUrl = 'https://' + siteName + domain; // always upgrade to HTTPS with the new site name

            return siteUrl;
        },

        "i18n": function(key, kwargs){
            // Escape any placeholders that are not SafeString objects
            for (var k in kwargs) {
                if (typeof kwargs[k] === 'string') {
                    kwargs[k] = Nunjucks.lib.escape(kwargs[k]);
                }
            }
            // Stop i18next from escaping any other values
            if (typeof kwargs === 'undefined') {
                kwargs = {interpolation: {escapeValue: false }};
            } else {
                kwargs.interpolation = { escapeValue: false };
            }

            var translation = this.t(key, kwargs);

            return Nunjucks.runtime.markSafe(translation);
        },

        "ngettext": function(key, keyp, num, kwargs){
            // hax, b/c there is no en json file being loaded:
            // add the key and plural for english at run time
            this.addResource('en', 'translation', key, key);
            this.addResource('en', 'translation', key + "_plural", keyp);
            return this.t(key, _.extend({}, {
                'num': num,
                'count': num
            }, kwargs));
        }
    };
});

